import {
  useFetchAppSubscriptionProducts,
  useFetchAppSubscriptions,
  useFetchBusinessPromoCode,
  useFetchCurrentBranchTimezone,
  useFetchEmployeesCount,
  useFetchPlanTypes,
} from '@expane/data'
import { Spinner } from '@expane/ui'
import { useFetchMyPermissions } from 'gql/employee'
import { SettingsWrapper } from 'pages/SettingsPage/index'
import { FC, useMemo } from 'react'
import { store } from 'store'
import { CurrentAppSubscriptionInfo } from './CurrentAppSubscriptionInfo'
import { CurrentRestrictions } from './CurrentRestrictions'
import { NotUsedPromoCode } from './NotUsedPromoCode'
import { AppSubscriptionProducts } from 'pages/SettingsPage/AppSubscriptionSettings/AppSubscriptionProducts'

export const AppSubscriptionSettings: FC = () => {
  const branchId = store.branch.branchId
  const timezone = useFetchCurrentBranchTimezone(branchId)

  const { data: appSubscriptionProducts, isLoading: isLoadingProducts } =
    useFetchAppSubscriptionProducts()
  const { data: appSubscriptions, isLoading: isLoadingAppSubscriptions } =
    useFetchAppSubscriptions(timezone)
  const { data: planTypes, isLoading: isLoadingPlanTypes } = useFetchPlanTypes()
  const { data: businessPromoCode, isLoading: isLoadingBusinessPromoCode } =
    useFetchBusinessPromoCode()

  const { data: employeeCount, isLoading: isEmployeeCountLoading } = useFetchEmployeesCount()
  const { isLoading: isLoadingMyPermissions } = useFetchMyPermissions()

  const activeSubscription = useMemo(() => {
    const now = new Date()

    const activeSubscriptions = appSubscriptions?.filter(appSubscription => {
      return (
        appSubscription.createdAt.getTime() < now.getTime() &&
        (!appSubscription.canceledAt || appSubscription.canceledAt.getTime() > now.getTime())
      )
    })

    if (activeSubscriptions && activeSubscriptions.length > 0) return activeSubscriptions[0]

    return undefined
  }, [appSubscriptions])

  const isLoading =
    isEmployeeCountLoading ||
    isLoadingMyPermissions ||
    isLoadingBusinessPromoCode ||
    isLoadingProducts ||
    isLoadingAppSubscriptions ||
    isLoadingPlanTypes ||
    !timezone

  if (isLoading) return <Spinner expandCentered />

  if (!appSubscriptionProducts || !planTypes) return null

  return (
    <SettingsWrapper>
      <CurrentAppSubscriptionInfo activeSubscription={activeSubscription} />
      {businessPromoCode && <NotUsedPromoCode businessPromoCode={businessPromoCode} />}
      <CurrentRestrictions />

      <AppSubscriptionProducts
        products={appSubscriptionProducts.products || []}
        planTypes={planTypes}
        activePlanType={activeSubscription?.planType}
        employeeCount={employeeCount || 1}
      />
    </SettingsWrapper>
  )
}
